import kr from 'Kr/kr';

export default class IndividualLogos extends kr.Component {
    init() {
        this.slider = new Swiper(this.$element, {
            loop: false,
            slidesPerView: 3,
            centeredSlides: true,
            draggable: true,
            autoplay: {
                delay: 4000,
            },
            
            breakpoints: {
                1200: {
                    slidesPerView: 6,
                    centeredSlides: false
                },
                200: {
                    slidesPerView: 3,
                    centeredSlides: false
                }
            }
        });   

        this._event();
    }

    _event() {
        this.on('mouseenter', (event, current) => {
            this.slider.autoplay.stop();
        });
        this.on('mouseleave', (event, current) => {
            this.slider.autoplay.start();
        });
    }
}

kr.registerComponent('.js--individual-logos', {
    component: IndividualLogos
});
